import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEarDeaf, faEarListen, faMicrophoneAlt } from '@fortawesome/free-solid-svg-icons';

interface LiveControlDockProps {
  caption: string;
  isMuted: boolean;
  liveListenButtonActive: boolean;
  liveMuteButtonEnabled: boolean;
  livePrimaryButtonText: string;
  livePrimaryControlBusy: boolean;
  liveVoiceSessionActive: boolean;
  onPrimaryAction: () => void | Promise<void>;
  onPrimaryPointerDown?: () => void;
  onToggleMute: () => void;
  primaryButtonTitle: string;
}

export function LiveControlDock({
  caption,
  isMuted,
  liveListenButtonActive,
  liveMuteButtonEnabled,
  livePrimaryButtonText,
  livePrimaryControlBusy,
  liveVoiceSessionActive,
  onPrimaryAction,
  onPrimaryPointerDown,
  onToggleMute,
  primaryButtonTitle
}: LiveControlDockProps) {
  return (
    <div
      style={{
        // Stretch a bottom tray across the full avatar surface so the
        // browser doesn't fall back to the element's static top position.
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: '20px',
        left: 0,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        padding: '0 16px',
        zIndex: 30,
        pointerEvents: 'none'
      }}
    >
      <div
        className="live-control-dock"
        style={{
          maxWidth: 'calc(100% - 24px)',
          pointerEvents: 'auto'
        }}
      >
        {caption && <div className="live-control-caption">{caption}</div>}
        <div className="live-control-buttons">
          <button
            type="button"
            className={`live-primary-control${liveVoiceSessionActive ? ' active' : ''}${livePrimaryControlBusy ? ' busy' : ''}`}
            disabled={livePrimaryControlBusy}
            aria-label={livePrimaryButtonText}
            title={primaryButtonTitle}
            onClick={() => { void onPrimaryAction(); }}
            onPointerDown={onPrimaryPointerDown}
          >
            <FontAwesomeIcon
              className={`live-control-button-icon${liveListenButtonActive ? ' listening-active' : ''}`}
              icon={faMicrophoneAlt}
            />
            <span className="live-control-button-text">{livePrimaryButtonText}</span>
          </button>
          {liveMuteButtonEnabled && (
            <button
              type="button"
              className={`live-secondary-control${isMuted ? ' active-mute' : ''}`}
              onClick={onToggleMute}
              disabled={!liveMuteButtonEnabled}
              aria-label={isMuted ? 'Unmute microphone' : 'Mute microphone'}
              title={isMuted ? 'Unmute microphone' : 'Mute microphone'}
            >
              <FontAwesomeIcon
                className="live-control-button-icon"
                icon={isMuted ? faEarDeaf : faEarListen}
              />
              <span className="live-control-button-text">{isMuted ? 'Unmute' : 'Mute'}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default LiveControlDock;
